export default "__VITE_ASSET__Bnzhsxh___"